"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Urls = require("./constants/Urls");

var _reducers = _interopRequireDefault(require("./reducers"));

var _epics = _interopRequireDefault(require("./epics"));

var _routes = _interopRequireDefault(require("./routes"));

var _default = {
  reducer: _reducers.default,
  rootEpic: _epics.default,
  routes: _routes.default,
  route: _Urls.MODULE_PATH
};
exports.default = _default;
module.exports = exports.default;